import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Form, Col, Row, Button, Container, InputGroup } from "react-bootstrap";
import * as yup from "yup";
import Cleave from "cleave.js/react";
import HelpIcon from "@material-ui/icons/Help";
import Select from "react-select";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import { emsBoot, getEmsBootEquipments } from ".././../../../api/index";
import { FaPlus } from "react-icons/fa";
import ContactInformation from "../v2/ContactInformation";
import PricingModel from "../v2/PricingModel";
import { Stack } from "@mui/material";

const phoneRegex =
    /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const schema = yup.object({
    field_dba: yup.string().trim().required("* DBA name is required"),
    field_businessemail: yup
        .string()
        .email("* Invalid email Address")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "no"
                ? schema
                : schema.required("* Email is required");
        }),
    field_businessphone: yup
        .string()
        .matches(phoneRegex, "* Enter mobile phone number correctly.")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "no"
                ? schema
                : schema.required("* Mobile phone number is required");
        }),
    pricing_model: yup
        .string()
        .trim()
        .required("* Please select Pricing Model"),
    expedited_funding: yup
        .string()
        .trim()
        .required("* Please select Expedited Funding"),
    dual_pricing_rate: yup
        .number()
        .when(["pricing_model"], (pricing_model, schema) => {
            return pricing_model == "dual_pricing"
                ? schema.required("Rate for Dual Pricing is required")
                : schema;
        }),
    new_to_processing_pricing_type: yup
        .string()
        .trim()
        .when(["pricing_model"], (pricing_model, schema) => {
            return pricing_model == "new_to_processing"
                ? schema.required("Please select pricing type")
                : schema;
        }),

    ntp_flat_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "flat_rate"
                    ? schema.required("Flat Rate is required")
                    : schema;
            },
        ),
    ntp_flat_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "flat_rate"
                    ? schema.required("Transaction Fee is required")
                    : schema;
            },
        ),
    ntp_amex_flat_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "flat_rate"
                    ? schema.required("Flat Rate is required")
                    : schema;
            },
        ),
    ntp_amex_flat_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "flat_rate"
                    ? schema.required("Transaction Fee is required")
                    : schema;
            },
        ),

    ntp_ic_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "ic_plus"
                    ? schema.required("IC Rate is required")
                    : schema;
            },
        ),
    ntp_ic_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "ic_plus"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    ntp_ic_amex_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "ic_plus"
                    ? schema.required("IC Rate is required")
                    : schema;
            },
        ),
    ntp_ic_amex_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "ic_plus"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),

    ntp_tiered_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    ntp_tiered_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    ntp_tiered_mid_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    ntp_tiered_mid_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    ntp_tiered_non_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    ntp_tiered_non_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    ntp_tiered_amex_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    ntp_tiered_amex_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "new_to_processing_pricing_type"],
            (pricing_model, new_to_processing_pricing_type, schema) => {
                return pricing_model == "new_to_processing" &&
                    new_to_processing_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),

    rate_desk_pricing_type: yup
        .string()
        .trim()
        .when(["pricing_model"], (pricing_model, schema) => {
            return pricing_model == "rate_desk"
                ? schema.required("Please select pricing type")
                : schema;
        }),

    rate_desk_ic_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "ic_plus"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_ic_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "ic_plus"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    rate_desk_ic_amex_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "ic_plus"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_ic_amex_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "ic_plus"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),

    rate_desk_flat_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "flat_rate"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_flat_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "flat_rate"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    rate_desk_flat_amex_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "flat_rate"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_flat_amex_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "flat_rate"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),

    rate_desk_tiered_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_tiered_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    rate_desk_tiered_mid_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_tiered_mid_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    rate_desk_tiered_non_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_tiered_non_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
    rate_desk_tiered_amex_qual_rate: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Rate is required")
                    : schema;
            },
        ),
    rate_desk_tiered_amex_qual_fee: yup
        .number()
        .when(
            ["pricing_model", "rate_desk_pricing_type"],
            (pricing_model, rate_desk_pricing_type, schema) => {
                return pricing_model == "rate_desk" &&
                    rate_desk_pricing_type == "tiered"
                    ? schema.required("Transaction fee is required")
                    : schema;
            },
        ),
});

function EMSBoot(props) {
    const [initialErrors, setInitialError] = useState([]);
    const [formData, setFormData] = useState({
        field_dba: "",
        field_businessemail: "",
        field_businessphone: "",
        pricing_model: "",
        // Dual pricing data
        dual_pricing_rate: "",
        // surcharge
        surcharge_rate: "3",
        // new to processing
        // flat rate
        ntp_flat_rate: "",
        ntp_flat_fee: "",
        ntp_amex_flat_rate: "",
        ntp_amex_flat_fee: "",
        // ic
        ntp_ic_rate: "",
        ntp_ic_fee: "",
        ntp_ic_amex_rate: "",
        ntp_ic_amex_fee: "",
        //Tiered
        ntp_tiered_qual_rate: "",
        ntp_tiered_qual_fee: "",
        ntp_tiered_mid_qual_rate: "",
        ntp_tiered_mid_qual_fee: "",
        ntp_tiered_non_qual_rate: "",
        ntp_tiered_non_qual_fee: "",
        ntp_tiered_amex_qual_rate: "",
        ntp_tiered_amex_qual_fee: "",
        // rate desk
        // ic_plus
        rate_desk_ic_rate: "",
        rate_desk_ic_fee: "",
        rate_desk_ic_amex_rate: "",
        rate_desk_ic_amex_fee: "",
        // flat_rate
        rate_desk_flat_rate: "",
        rate_desk_flat_fee: "",
        rate_desk_flat_amex_rate: "",
        rate_desk_flat_amex_fee: "",
        // tiered
        rate_desk_tiered_qual_rate: "",
        rate_desk_tiered_qual_fee: "",
        rate_desk_tiered_mid_qual_rate: "",
        rate_desk_tiered_mid_qual_fee: "",
        rate_desk_tiered_non_qual_rate: "",
        rate_desk_tiered_non_qual_fee: "",
        rate_desk_tiered_amex_qual_rate: "",
        rate_desk_tiered_amex_qual_fee: "",
        // ////////////////
        monthly_fee: 49,
        new_to_processing_pricing_type: "",
        rate_desk_pricing_type: "",
        expedited_funding: "",
        expedited_rate: "3.50",
        expedited_fee: "0.15",
    });
    const [is_submitted, setIsSubmitted] = useState(false);
    const [ems_equipments, setEmsEquipments] = useState([]);
    const [equipment_data, setEquipmentData] = useState([
        {
            equipment: "",
            quantity: "",
            monthly_sass_subs_fee: "",
            monthly_rental_fee: "",
            purchase_price: "",
            tpp: "",
        },
    ]);
    const pricing_model_options = [
        { label: "Dual Pricing", value: "dual_pricing" },
        { label: "Surcharge", value: "surcharge" },
        { label: "New to Processing", value: "new_to_processing" },
        { label: "Custom Rate Desk", value: "rate_desk" },
    ];

    const updateChange = (event) => {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        const value = event.target.value.trim();
        setFormData({
            ...formData,
            [targetName]: value,
        });
    };

    const submitForm = (e) => {
        console.log(e);
    };

    useEffect(() => {
        getEmsBootEquipments().then((res) => {
            console.log("ppppppp", res);
            let ems_equipments_list = res.data.map((item) => ({
                label: item.equipment_name,
                value: item.equipment_slug,
            }));
            setEmsEquipments(ems_equipments_list);
            console.log(ems_equipments_list);
        });
    }, []);

    return (
        <div className="ems-boot-modal">
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(e) => submitForm(e)}
                initialValues={formData}
                initialErrors={initialErrors}
                validateOnBlur={true}
                validateOnChange={true}
                validateOnMount={false}
                validate={(values) => {
                    setIsSubmitted(true);
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    errors,
                    handleBlur,
                }) => (
                    <>
                        <Form
                            id="ems-boot-form"
                            onSubmit={handleSubmit}
                            onChange={(e) => updateChange(e)}
                            autoComplete="off"
                        >
                            <Form.Row>
                                <Form.Group as={Col} xs={12} className="px-3">
                                    <Form.Control
                                        placeholder="DBA Name"
                                        type="text"
                                        name="field_dba"
                                        value={values.field_dba}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_dba &&
                                            !!errors.field_dba
                                        }
                                        isValid={
                                            is_submitted && !errors.field_dba
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        DBA Name *
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {errors.field_dba}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} xs={12} className="px-3">
                                    <Form.Control
                                        placeholder="Email"
                                        type="email"
                                        name="field_businessemail"
                                        value={values.field_businessemail}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_businessemail &&
                                            !!errors.field_businessemail
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_businessemail
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        Business Email *
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {errors.field_businessemail}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group
                                    className="px-3 field_businessphone"
                                    controlId="field_businessphone"
                                >
                                    <div className="d-flex flex-row phone-prefix">
                                        <Cleave
                                            options={{
                                                blocks: [3, 3, 4],
                                                delimiter: "-",
                                                numericOnly: true,
                                            }}
                                            placeholder="Mobile Phone"
                                            name="field_businessphone"
                                            value={values.field_businessphone}
                                            onChange={handleChange}
                                            type="text"
                                            inputMode="numeric"
                                            className={`preapp-form-input form-control ${
                                                is_submitted &&
                                                !errors.field_businessphone &&
                                                "is-valid"
                                            } ${
                                                touched.field_businessphone &&
                                                !!errors.field_businessphone &&
                                                "is-invalid"
                                            }`}
                                        />
                                    </div>
                                    <label className="modal-lab">
                                        Mobile Phone *{" "}
                                        <HelpIcon
                                            id="myHelpIcon"
                                            data-tip
                                            data-for="registerTip-phone"
                                        />{" "}
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {errors.field_businessphone}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group
                                    className="px-3"
                                    controlId="pricing_model"
                                >
                                    <SelectDropDown
                                        options={pricing_model_options}
                                        name={"pricing_model"}
                                        handleChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                pricing_model: selected.value,
                                            });
                                        }}
                                        value={values.pricing_model}
                                    />
                                    <label className="modal-lab">
                                        Pricing Model
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {errors.pricing_model}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>

                            {values.pricing_model !== "" && (
                                <>
                                    {values.pricing_model == "dual_pricing" && (
                                        <Form.Row>
                                            <Form.Group
                                                className="px-3"
                                                controlId="rate"
                                            >
                                                <label className="modal-lab">
                                                    Rate
                                                </label>
                                                <div className="row">
                                                    <div className="col-md-2 col-sm-2 col-xs-3">
                                                        <Form.Check
                                                            inline
                                                            label="3%"
                                                            id="rate_3"
                                                            checked={
                                                                values.dual_pricing_rate ==
                                                                3
                                                            }
                                                            value={3}
                                                            name="dual_pricing_rate"
                                                            type="radio"
                                                            onChange={
                                                                handleChange
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-md-2 col-sm-2 col-xs-3">
                                                        <Form.Check
                                                            inline
                                                            label="3.5%"
                                                            id="rate_35"
                                                            checked={
                                                                values.dual_pricing_rate ==
                                                                3.5
                                                            }
                                                            value={3.5}
                                                            name="dual_pricing_rate"
                                                            type="radio"
                                                            onChange={
                                                                handleChange
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-md-2 col-sm-2 col-xs-3">
                                                        <Form.Check
                                                            inline
                                                            label="4%"
                                                            id="rate_4"
                                                            checked={
                                                                values.dual_pricing_rate ==
                                                                4
                                                            }
                                                            value={4}
                                                            name="dual_pricing_rate"
                                                            type="radio"
                                                            onChange={
                                                                handleChange
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.dual_pricing_rate}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Form.Row>
                                    )}

                                    {values.pricing_model == "surcharge" && (
                                        <Form.Row>
                                            <Form.Group
                                                as={Col}
                                                sm={1}
                                                className="col-xs-2"
                                            >
                                                <Form.Label>Rate</Form.Label>
                                            </Form.Group>
                                            <Form.Group
                                                as={Col}
                                                sm={11}
                                                className="col-xs-10"
                                            >
                                                <Form.Label>3%</Form.Label>
                                            </Form.Group>
                                        </Form.Row>
                                    )}

                                    {values.pricing_model ==
                                        "new_to_processing" && (
                                        <>
                                            <Form.Row>
                                                <Form.Group
                                                    className="px-3"
                                                    controlId="rate"
                                                >
                                                    <>
                                                        <label className="modal-lab">
                                                            Pricing Type
                                                        </label>
                                                        <div className="row">
                                                            <div className="col-md-3 col-sm-3 col-xs-5">
                                                                <Form.Check
                                                                    inline
                                                                    label="Flat Rate"
                                                                    checked={
                                                                        values.new_to_processing_pricing_type ==
                                                                        "flat_rate"
                                                                    }
                                                                    value={
                                                                        "flat_rate"
                                                                    }
                                                                    name="new_to_processing_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-md-3 col-sm-3 col-xs-3">
                                                                <Form.Check
                                                                    inline
                                                                    label="IC+"
                                                                    checked={
                                                                        values.new_to_processing_pricing_type ==
                                                                        "ic_plus"
                                                                    }
                                                                    value={
                                                                        "ic_plus"
                                                                    }
                                                                    name="new_to_processing_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-md-3 col-sm-3 col-xs-3">
                                                                <Form.Check
                                                                    inline
                                                                    label="Tiered"
                                                                    checked={
                                                                        values.new_to_processing_pricing_type ==
                                                                        "tiered"
                                                                    }
                                                                    value={
                                                                        "tiered"
                                                                    }
                                                                    name="new_to_processing_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.new_to_processing_pricing_type
                                                            }
                                                        </Form.Control.Feedback>
                                                    </>
                                                </Form.Group>
                                            </Form.Row>

                                            {values.new_to_processing_pricing_type ==
                                                "flat_rate" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="ntp_flat_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_flat_rate"
                                                                    value={
                                                                        values.ntp_flat_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_flat_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_flat_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_flat_fee"
                                                                    value={
                                                                        values.ntp_flat_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_flat_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex Pricing
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="ntp_amex_flat_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_amex_flat_rate"
                                                                    value={
                                                                        values.ntp_amex_flat_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_amex_flat_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_amex_flat_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_amex_flat_fee"
                                                                    value={
                                                                        values.ntp_amex_flat_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_amex_flat_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}

                                            {values.new_to_processing_pricing_type ==
                                                "ic_plus" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="ntp_ic_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_ic_rate"
                                                                    value={
                                                                        values.ntp_ic_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_ic_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_ic_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_ic_fee"
                                                                    value={
                                                                        values.ntp_ic_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_ic_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex Pricing
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="ntp_ic_amex_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_ic_amex_rate"
                                                                    value={
                                                                        values.ntp_ic_amex_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_ic_amex_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_ic_amex_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_ic_amex_fee"
                                                                    value={
                                                                        values.ntp_ic_amex_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_ic_amex_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}

                                            {values.new_to_processing_pricing_type ==
                                                "tiered" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_qual_rate"
                                                                    value={
                                                                        values.ntp_tiered_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_qual_fee"
                                                                    value={
                                                                        values.ntp_tiered_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Mid Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_mid_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_mid_qual_rate"
                                                                    value={
                                                                        values.ntp_tiered_mid_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_mid_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_mid_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_mid_qual_fee"
                                                                    value={
                                                                        values.ntp_tiered_mid_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_mid_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Non Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_non_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_non_qual_rate"
                                                                    value={
                                                                        values.ntp_tiered_non_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_non_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_non_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_non_qual_fee"
                                                                    value={
                                                                        values.ntp_tiered_non_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_non_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_amex_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_amex_qual_rate"
                                                                    value={
                                                                        values.ntp_tiered_amex_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_amex_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="ntp_tiered_amex_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="ntp_tiered_amex_qual_fee"
                                                                    value={
                                                                        values.ntp_tiered_amex_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.ntp_tiered_amex_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {values.pricing_model == "rate_desk" && (
                                        <>
                                            <Form.Row>
                                                <Form.Group
                                                    className="px-3"
                                                    controlId="rate"
                                                >
                                                    <>
                                                        <label className="modal-lab">
                                                            Pricing Type
                                                        </label>
                                                        <div className="row">
                                                            <div className="col-md-3 col-sm-3 col-xs-7">
                                                                <Form.Check
                                                                    inline
                                                                    label="Flat Rate"
                                                                    checked={
                                                                        values.rate_desk_pricing_type ==
                                                                        "flat_rate"
                                                                    }
                                                                    value={
                                                                        "flat_rate"
                                                                    }
                                                                    name="rate_desk_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-md-3 col-sm-3 col-xs-7">
                                                                <Form.Check
                                                                    inline
                                                                    label="IC+"
                                                                    checked={
                                                                        values.rate_desk_pricing_type ==
                                                                        "ic_plus"
                                                                    }
                                                                    value={
                                                                        "ic_plus"
                                                                    }
                                                                    name="rate_desk_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="col-md-3 col-sm-3 col-xs-3">
                                                                <Form.Check
                                                                    inline
                                                                    label="Tiered"
                                                                    checked={
                                                                        values.rate_desk_pricing_type ==
                                                                        "tiered"
                                                                    }
                                                                    value={
                                                                        "tiered"
                                                                    }
                                                                    name="rate_desk_pricing_type"
                                                                    type="radio"
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.rate_desk_pricing_type
                                                            }
                                                        </Form.Control.Feedback>
                                                    </>
                                                </Form.Group>
                                            </Form.Row>

                                            {values.rate_desk_pricing_type ==
                                                "ic_plus" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label>
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="rate_desk_ic_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_ic_rate"
                                                                    value={
                                                                        values.rate_desk_ic_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_ic_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_ic_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_ic_fee"
                                                                    value={
                                                                        values.rate_desk_ic_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_ic_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex Pricing
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="rate_desk_ic_amex_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_ic_amex_rate"
                                                                    value={
                                                                        values.rate_desk_ic_amex_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_ic_amex_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_ic_amex_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_ic_amex_fee"
                                                                    value={
                                                                        values.rate_desk_ic_amex_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_ic_amex_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}

                                            {values.rate_desk_pricing_type ==
                                                "flat_rate" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label>
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="rate_desk_flat_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_flat_rate"
                                                                    value={
                                                                        values.rate_desk_flat_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_flat_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_flat_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_flat_fee"
                                                                    value={
                                                                        values.rate_desk_flat_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_flat_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex Pricing
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={2}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Flat Rate
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={3}
                                                            sm={3}
                                                            controlId="rate_desk_flat_amex_rate"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_flat_amex_rate"
                                                                    value={
                                                                        values.rate_desk_flat_amex_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_flat_amex_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={3}
                                                            className="col-xs-6"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Transaction Fee
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_flat_amex_fee"
                                                            className="col-xs-6"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_flat_amex_fee"
                                                                    value={
                                                                        values.rate_desk_flat_amex_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_flat_amex_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}

                                            {values.rate_desk_pricing_type ==
                                                "tiered" && (
                                                <>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_qual_rate"
                                                                    value={
                                                                        values.rate_desk_tiered_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_qual_fee"
                                                                    value={
                                                                        values.rate_desk_tiered_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Mid Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_mid_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_mid_qual_rate"
                                                                    value={
                                                                        values.rate_desk_tiered_mid_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_mid_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_mid_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_mid_qual_fee"
                                                                    value={
                                                                        values.rate_desk_tiered_mid_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_mid_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Non Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_non_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_non_qual_rate"
                                                                    value={
                                                                        values.rate_desk_tiered_non_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_non_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_non_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_non_qual_fee"
                                                                    value={
                                                                        values.rate_desk_tiered_non_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_non_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>

                                                    {/* Amex */}
                                                    <label className="modal-lab">
                                                        Amex
                                                    </label>
                                                    <Form.Row>
                                                        <Form.Group
                                                            as={Col}
                                                            sm={4}
                                                            className="col-xs-4"
                                                        >
                                                            <Form.Label className="mt-10p">
                                                                Qual
                                                            </Form.Label>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_amex_qual_rate"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        %
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_amex_qual_rate"
                                                                    value={
                                                                        values.rate_desk_tiered_amex_qual_rate
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_amex_qual_rate
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group
                                                            as={Col}
                                                            xs={4}
                                                            sm={4}
                                                            controlId="rate_desk_tiered_amex_qual_fee"
                                                            className="col-xs-4"
                                                        >
                                                            <InputGroup className="display-flex">
                                                                <InputGroup.Prepend>
                                                                    <InputGroup.Text id="inputGroupPrepend">
                                                                        $
                                                                    </InputGroup.Text>
                                                                </InputGroup.Prepend>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="rate_desk_tiered_amex_qual_fee"
                                                                    value={
                                                                        values.rate_desk_tiered_amex_qual_fee
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    aria-describedby="inputGroupPrepend"
                                                                    className="preapp-form-input"
                                                                />
                                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                            </InputGroup>
                                                            <Form.Control.Feedback
                                                                type="invalid"
                                                                className="text-capitalize"
                                                            >
                                                                {
                                                                    errors.rate_desk_tiered_amex_qual_fee
                                                                }
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Form.Row>
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            <Form.Row>
                                <Form.Group className="px-3" controlId="rate">
                                    <>
                                        <label className="modal-lab">
                                            Expedited Funding
                                        </label>
                                        <div className="row">
                                            <div className="col-md-2 col-sm-2 col-xs-3">
                                                <Form.Check
                                                    inline
                                                    label="Yes"
                                                    value={"yes"}
                                                    name="expedited_funding"
                                                    type="radio"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-2 col-sm-2 col-xs-3">
                                                <Form.Check
                                                    inline
                                                    label="No"
                                                    value="no"
                                                    name="expedited_funding"
                                                    type="radio"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {errors.expedited_funding}
                                        </Form.Control.Feedback>
                                    </>
                                </Form.Group>
                            </Form.Row>

                            {values.expedited_funding == "yes" && (
                                <>
                                    <label className="modal-lab">
                                        Amex Pricing
                                    </label>
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={2}
                                            xs={2}
                                            className="col-xs-2"
                                        >
                                            <Form.Label className="mt-10p">
                                                Rate
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={4}
                                            sm={4}
                                            controlId="expedited_rate"
                                            className="col-xs-4"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        %
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="expedited_rate"
                                                    value={"3.50"}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input disabled-boot"
                                                    disabled={true}
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {/* {errors.price_12_dollars} */}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            sm={3}
                                            xs={3}
                                            className="col-xs-2"
                                        >
                                            <Form.Label className="mt-10p">
                                                Fee
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={3}
                                            sm={3}
                                            controlId="expedited_fee"
                                            className="col-xs-4"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="expedited_fee"
                                                    value={0.15}
                                                    onChange={handleChange}
                                                    className="preapp-form-input disabled-boot"
                                                    disabled={true}
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {/* {errors.price_12_dollars} */}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                </>
                            )}

                            {/* Default Values */}
                            <p
                                className="modal-lab"
                                style={{ marginBottom: "18px" }}
                            >
                                Defaults
                            </p>
                            {values.pricing_model == "dual_pricing" && (
                                <>
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                $ Per Transaction
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={
                                                        values.rate_desk_ic_rate
                                                    }
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Monthly Fee</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={0}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                </>
                            )}

                            {values.pricing_model == "surcharge" && (
                                <>
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Monthly Fee</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={0}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                </>
                            )}

                            {values.pricing_model == "new_to_processing" && (
                                <>
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                Monthly Access Fee
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={15}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                100k Data Breach
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={15}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Monthly Min</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={25}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                Semi Annual Tech Fee
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={"null"}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Voice ARU</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={"null"}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Batch Fee</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={0.1}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>AVS</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                </>
                            )}

                            {values.pricing_model == "rate_desk" && (
                                <>
                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                Monthly Access Fee
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={15}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                100k Data Breach
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={15}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Monthly Min</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    value={25}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>
                                                Semi Annual Tech Fee
                                            </Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={"null"}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Voice ARU</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={"null"}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>Batch Fee</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={0.10}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group
                                            as={Col}
                                            sm={4}
                                            className="col-xs-6"
                                        >
                                            <Form.Label>AVS</Form.Label>
                                        </Form.Group>

                                        <Form.Group
                                            as={Col}
                                            xs={8}
                                            sm={8}
                                            controlId="rate_desk_ic_rate"
                                            className="col-xs-8"
                                        >
                                            <InputGroup className="display-flex">
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text id="inputGroupPrepend">
                                                        $
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control
                                                    type="text"
                                                    name="rate_desk_ic_rate"
                                                    // value={}
                                                    onChange={handleChange}
                                                    aria-describedby="inputGroupPrepend"
                                                    className="preapp-form-input"
                                                />
                                                <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                            </InputGroup>
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {errors.rate_desk_ic_rate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                </>
                            )}

                            {/* Equipment */}
                            <p
                                className="modal-lab"
                                style={{ marginBottom: "18px" }}
                            >
                                Equipments
                            </p>
                            <div className="row">
                                <div className="col-md-11"></div>
                                <div className="col-md-1">
                                    <button
                                        className="btn confirm-button"
                                        type="button"
                                        onClick={() =>
                                            setEquipmentData([
                                                ...equipment_data,
                                                {
                                                    equipment: "",
                                                    quantity: "",
                                                    monthly_sass_subs_fee: "",
                                                    monthly_rental_fee: "",
                                                    purchase_price: "",
                                                    tpp: "",
                                                },
                                            ])
                                        }
                                        form="ems-boot-form"
                                    >
                                        {" "}
                                        <FaPlus />
                                    </button>
                                </div>
                            </div>
                            <table className="equipment-table">
                                <thead>
                                    <tr>
                                        <th>Equipment</th>
                                        <th>Quantity</th>
                                        <th>Monthly Sass Subscription Fee</th>
                                        <th>Monthly Rental Fee</th>
                                        <th>Purchase Price</th>
                                        <th>TPP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {equipment_data.map((item) => (
                                        <tr>
                                            <td>
                                                <Form.Control
                                                    as="select"
                                                    className="preapp-form-input"
                                                >
                                                    <option>
                                                        Select Equipment
                                                    </option>
                                                    {ems_equipments.map(
                                                        (item) => (
                                                            <option
                                                                value={
                                                                    item.value
                                                                }
                                                            >
                                                                {item.label}
                                                            </option>
                                                        ),
                                                    )}
                                                </Form.Control>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    placeholder="Quantity"
                                                    type="number"
                                                    name="field_dba"
                                                    // value={values.field_dba}
                                                    onChange={handleChange}
                                                    isInvalid={
                                                        touched.field_dba &&
                                                        !!errors.field_dba
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.field_dba
                                                    }
                                                    className="preapp-form-input"
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    placeholder="$"
                                                    type="text"
                                                    name="field_dba"
                                                    // value={values.field_dba}
                                                    onChange={handleChange}
                                                    isInvalid={
                                                        touched.field_dba &&
                                                        !!errors.field_dba
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.field_dba
                                                    }
                                                    className="preapp-form-input"
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    placeholder="$"
                                                    type="number"
                                                    name="field_dba"
                                                    // value={values.field_dba}
                                                    onChange={handleChange}
                                                    isInvalid={
                                                        touched.field_dba &&
                                                        !!errors.field_dba
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.field_dba
                                                    }
                                                    className="preapp-form-input"
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    placeholder="$"
                                                    type="text"
                                                    name="field_dba"
                                                    // value={values.field_dba}
                                                    onChange={handleChange}
                                                    isInvalid={
                                                        touched.field_dba &&
                                                        !!errors.field_dba
                                                    }
                                                    isValid={
                                                        is_submitted &&
                                                        !errors.field_dba
                                                    }
                                                    className="preapp-form-input"
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    as="select"
                                                    className="preapp-form-input"
                                                >
                                                    <option>
                                                        Yes &nbsp; &nbsp; &nbsp;
                                                    </option>
                                                    <option>
                                                        No &nbsp; &nbsp; &nbsp;
                                                    </option>
                                                </Form.Control>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Form>
                        <div className="modal-footer-boot">
                            <div className="row">
                                <div className="col-md-4 col-sm-4"></div>
                                <div
                                    className="col-md-4 col-sm-4"
                                    style={{ marginTop: "24px" }}
                                >
                                    <button
                                        className="btn confirm-button"
                                        type="submit"
                                        form="ems-boot-form"
                                    >
                                        {" "}
                                        Submit{" "}
                                    </button>
                                    <button
                                        className="btn cancel-button"
                                        onClick={() => props.close()}
                                    >
                                        {" "}
                                        Cancel{" "}
                                    </button>
                                </div>
                                <div className="col-md-4 col-sm-4"></div>
                            </div>
                        </div>
                    </>
                )}
            </Formik>
        </div>
    );
}

export default EMSBoot;
